import { AmplitudeEvent } from 'utils/tracking/amplitude/amplitude.interface'
import BugsnagError, { Metadata } from './bugsnagError'

interface AmplitudeMetadata {
  code?: number
  reason?: string
  body?: string
}

export default class AmplitudeError extends BugsnagError {
  public event: AmplitudeEvent
  public meta: AmplitudeMetadata

  constructor(event: AmplitudeEvent, meta: AmplitudeMetadata = {}) {
    super(`[${event}] ${meta.reason ? meta.reason : 'Something went wrong :/'}`)

    this.name = 'AmplitudeError'
    this.event = event
    this.meta = meta
  }

  getMetadata(): Metadata {
    const { code = -1, reason = '', body = '' } = this.meta

    return {
      amplitude: {
        event: this.event,
        error: { code, reason, body }
      }
    }
  }
}
